(ns bp-clients.tv-app.nav.views.nav
  "Namespace for main navigation view"
  (:require
   [bp-clients.tv-app.api.subs :as api-subs]
   [bp-clients.tv-app.auth.subs :as auth-subs]
   [bp-clients.tv-app.common.subs :as common-subs]
   [bp-clients.tv-app.nav.subs :as nav-subs]
   [bp-clients.tv-app.nav.views.authenticated :refer [authenticated]]
   [bp-clients.tv-app.nav.views.error-page :refer [error-page]]
   [bp-clients.tv-app.nav.views.initial-page :refer [initial-page]]
   [bp-clients.tv-app.nav.views.loading :refer [loading]]
   [bp-clients.tv-app.nav.views.login-page :refer [login-page-with-focus]]
   [bp-clients.tv-app.nav.views.logout-page :refer [logout-page]]
   [bp-clients.tv-app.nav.views.paywall :refer [paywall]]
   [bp-clients.tv-app.nav.views.register-page :refer [register-page]]
   [bp-clients.tv-app.nav.views.welcome-modal :refer [get-local-storage-welcome-modal-showed! welcome-modal]]
   [re-frame.core :as rf]))

(defn nav
  "Present user with main navigation based on user logged-in? state"
  [page]
  (let [logged-in?            @(rf/subscribe [::auth-subs/logged-in?])
        api-loaded?           @(rf/subscribe [::api-subs/api-loaded?])
        active-page           @(rf/subscribe [::nav-subs/active-page])
        page-loaded?          @(rf/subscribe [::nav-subs/active-page-loaded?])
        error-queue           @(rf/subscribe [::common-subs/error-queue])
        paywall-data          @(rf/subscribe [::nav-subs/paywall])
        welcome-modal-showed? @(rf/subscribe [::common-subs/welcome-modal-showed?])
        welcome-modal-showed? (or welcome-modal-showed? (get-local-storage-welcome-modal-showed!))]

    (cond
      (seq error-queue)                            [error-page error-queue]
      (not (nil? paywall-data))                    [paywall paywall-data]
      (and (not logged-in?) (not api-loaded?))     [loading]
      (and logged-in? (not welcome-modal-showed?)) [welcome-modal]
      (and logged-in? api-loaded? page-loaded?)    [authenticated page]
      (= :register active-page)                    [register-page]
      (= :login active-page)                       [login-page-with-focus]
      (= :logout active-page)                      [logout-page]
      (not logged-in?)                             [initial-page]

      :else                                        [loading])))
